import Vue from 'vue'


import 'quasar/dist/quasar.css'
import '@quasar/extras/roboto-font/roboto-font.css'
import '@quasar/extras/material-icons/material-icons.css'
import '@quasar/extras/fontawesome-v5/fontawesome-v5.css'
import { Loading, Cookies } from 'quasar'

import {
  Quasar, 
  QLayout,
  QHeader,
  QDrawer,
  QPageContainer,
  QPage,
  QToolbar,
  QToolbarTitle,
  QBtn,
  QIcon,
  QList,
  QItem,
  QItemSection,
  QItemLabel,
  QField, 
  QInput,
  Notify,
  QExpansionItem,
  Ripple,
  QBadge,
  TouchSwipe,
  QCard,
  QCardSection,
  QCardActions,
  QSeparator,
  QDialog,
  QAvatar,
  QSpace,
  QScrollArea,
  QUploader,
  QTable,
  QForm,
  QToggle,
  QSelect,
  QPopupProxy,
  QDate,
  QCheckbox,
  Dialog,
  ClosePopup,
  QEditor,
  QBtnDropdown,
  QTooltip,
  QSpinner,
  QTree,
  QPagination,
  QOptionGroup,
  QRadio

} from 'quasar'

Vue.use(Quasar, {
  config: {},
  components: {
    QLayout,
    QHeader,
    QDrawer,
    QPageContainer,
    QPage,
    QToolbar,
    QToolbarTitle,
    QBtn,
    QIcon,
    QList,
    QItem,
    QItemSection,
    QItemLabel,
    QField, 
    QInput,
    QExpansionItem,
    QBadge,
    QCard,
    QCardSection,
    QCardActions,
    QSeparator,
    QDialog,
    QAvatar,
    QSpace,
    QScrollArea,
    QUploader,
    QTable,
    QForm,
    QToggle,
    QSelect,
    QPopupProxy,
    QDate,
    QCheckbox,
    QEditor,
    QBtnDropdown,
    QTooltip,
    QSpinner,
    QTree,
    QPagination,
    QOptionGroup,
    QRadio
  },
  directives: {
    Ripple,
    TouchSwipe,
    ClosePopup
  },
  plugins: {
    Notify,
    Dialog,
    Loading,
    Cookies
  }
 })